module.exports = __webpack_public_path__ + "img/arrow_diagonal_up_right_purple.59a9ed2a.svg";